"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._claimETHFromRageQuit = exports._batchClaimETHFromRageQuit = exports._partialWithdrawal = exports._batchPartialWithdrawal = exports._previewPartialETHWithdrawalAmount = exports._approveProtectedStakingPoolToTransferDETH = exports._getdETHRequiredToIsolateWithdrawnKnot = exports._depositDETHForStaking = exports._isDETHReadyForWithdrawal = exports._burnLPToken = exports._burnLPTokens = exports._depositETHForStaking = exports._batchDepositETHForStaking = exports._getIndexOwnedByTheVault = void 0;
const constants_1 = require("./constants");
const contracts_1 = require("./contracts");
const utils_1 = require("./utils");
const _getIndexOwnedByTheVault = (signer, savETHVaultAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.indexOwnedByTheVault();
});
exports._getIndexOwnedByTheVault = _getIndexOwnedByTheVault;
const _batchDepositETHForStaking = (signer, savETHVaultAddress, blsPublicKeys, amounts, ethValue) => __awaiter(void 0, void 0, void 0, function* () {
    if (blsPublicKeys.length != amounts.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < blsPublicKeys.length; ++i) {
        blsPublicKeys[i] = (0, utils_1._add0x)(blsPublicKeys[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.batchDepositETHForStaking(blsPublicKeys, amounts, { value: ethValue });
});
exports._batchDepositETHForStaking = _batchDepositETHForStaking;
const _depositETHForStaking = (signer, savETHVaultAddress, blsPublicKey, amount, ethValue) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports._batchDepositETHForStaking)(signer, savETHVaultAddress, [blsPublicKey], [amount], ethValue);
});
exports._depositETHForStaking = _depositETHForStaking;
const _burnLPTokens = (signer, savETHVaultAddress, lpTokens, amounts) => __awaiter(void 0, void 0, void 0, function* () {
    if (lpTokens.length != amounts.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < lpTokens.length; ++i) {
        lpTokens[i] = (0, utils_1._add0x)(lpTokens[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.burnLPTokens(lpTokens, amounts);
});
exports._burnLPTokens = _burnLPTokens;
const _burnLPToken = (signer, savETHVaultAddress, lpToken, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.burnLPToken((0, utils_1._add0x)(lpToken), amount);
});
exports._burnLPToken = _burnLPToken;
const _isDETHReadyForWithdrawal = (signer, savETHVaultAddress, lpToken) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.isDETHReadyForWithdrawal(lpToken);
});
exports._isDETHReadyForWithdrawal = _isDETHReadyForWithdrawal;
const _depositDETHForStaking = (signer, savETHVaultAddress, blsPublicKey, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.depositDETHForStaking((0, utils_1._add0x)(blsPublicKey), amount);
});
exports._depositDETHForStaking = _depositDETHForStaking;
const _getdETHRequiredToIsolateWithdrawnKnot = (signer, savETHVaultAddress, blsPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.dETHRequiredToIsolateWithdrawnKnot((0, utils_1._add0x)(blsPublicKey));
});
exports._getdETHRequiredToIsolateWithdrawnKnot = _getdETHRequiredToIsolateWithdrawnKnot;
const _approveProtectedStakingPoolToTransferDETH = (signer, spender, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).dETH();
    return contract.approve((0, utils_1._add0x)(spender), amount);
});
exports._approveProtectedStakingPoolToTransferDETH = _approveProtectedStakingPoolToTransferDETH;
const _previewPartialETHWithdrawalAmount = (signer, savETHVaultAddress, user, lpTokens) => __awaiter(void 0, void 0, void 0, function* () {
    for (let i = 0; i < lpTokens.length; ++i) {
        lpTokens[i] = (0, utils_1._add0x)(lpTokens[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.previewPartialETHWithdrawalAmount((0, utils_1._add0x)(user), lpTokens);
});
exports._previewPartialETHWithdrawalAmount = _previewPartialETHWithdrawalAmount;
const _batchPartialWithdrawal = (signer, savETHVaultAddress, lpTokens, amounts) => __awaiter(void 0, void 0, void 0, function* () {
    if (lpTokens.length != amounts.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < lpTokens.length; ++i) {
        lpTokens[i] = (0, utils_1._add0x)(lpTokens[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.batchPartialWithdrawal(lpTokens, amounts);
});
exports._batchPartialWithdrawal = _batchPartialWithdrawal;
const _partialWithdrawal = (signer, savETHVaultAddress, lpToken, amount) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports._batchPartialWithdrawal)(signer, savETHVaultAddress, [lpToken], [amount]);
});
exports._partialWithdrawal = _partialWithdrawal;
const _batchClaimETHFromRageQuit = (signer, savETHVaultAddress, lpTokens, amounts) => __awaiter(void 0, void 0, void 0, function* () {
    if (lpTokens.length != amounts.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < lpTokens.length; ++i) {
        lpTokens[i] = (0, utils_1._add0x)(lpTokens[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).savETHVault(savETHVaultAddress);
    return contract.batchClaimETHFromRageQuit(lpTokens, amounts);
});
exports._batchClaimETHFromRageQuit = _batchClaimETHFromRageQuit;
const _claimETHFromRageQuit = (signer, savETHVaultAddress, lpToken, amount) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports._batchClaimETHFromRageQuit)(signer, savETHVaultAddress, [lpToken], [amount]);
});
exports._claimETHFromRageQuit = _claimETHFromRageQuit;
